module.exports = __webpack_public_path__ + "img/103.e3a8cda1.svg";